import React, { FC } from "react";
import { Text } from "@mantine/core";

import {
  getImplantRetentionTypeLabel,
  getItemAbutmentMaterialLabel,
  getItemAbutmentTypeLabel,
  getItemShadeLabel,
  getItemMultiShadeLabel,
} from "../../utils/item.utils";
import { ImplantItem } from "../../types/interfaces";
import { TeethShadeType, AbutmentType } from "../../types/enums";

type ItemsDescriptionProps = {
  item: ImplantItem;
  shouldTranslate: boolean;
};

export const ItemsDescriptionImplantItem: FC<ItemsDescriptionProps> = ({
  item,
  shouldTranslate,
}) => {
  return (
    <>
      {item?.itemShade && (
        <Text size="sm">{`- ${getItemShadeLabel(item)}`}</Text>
      )}
      {item?.teethshadeType === TeethShadeType.MULTI_SHADE && (
        <>
          <Text size="sm">- {shouldTranslate ? "Shade" : "Teinte"}:</Text>
          <Text
            size="sm"
            style={{ whiteSpace: "pre-line", marginLeft: "1rem" }}
          >{`${getItemMultiShadeLabel(item, shouldTranslate)}`}</Text>
        </>
      )}

      {item?.implantReferenceSuggestion && (
        <Text size="sm">
          {shouldTranslate
            ? `- Implant reference suggestion: ${item.implantReferenceSuggestion}`
            : `- Référence d'implant: ${item.implantReferenceSuggestion}`}
        </Text>
      )}
      {item?.scanBodySuggestion && (
        <Text size="sm">{`- Scan body: ${item.scanBodySuggestion}`}</Text>
      )}
      {item?.implantPlatform && (
        <Text size="sm">{`- Implant platform: ${item.implantPlatform}`}</Text>
      )}
      {item?.implantReference && (
        <>
          <Text size="sm">{`${shouldTranslate ? "- Implant brand:" : "- Marque d'implant:"} ${item.implantReference?.brand}`}</Text>
          <Text size="sm">{`${shouldTranslate ? "- Implant reference:" : "- Référence d'implant:"} ${item.implantReference?.label}`}</Text>
        </>
      )}
      {item?.standardAbutmentSuggestion && (
        <Text size="sm">{`${shouldTranslate ? "- Standard abutment suggestion:" : "- Suggestion d'abutement standard:"} ${item.standardAbutmentSuggestion}`}</Text>
      )}
      {getItemAbutmentTypeLabel(item) && !shouldTranslate && (
        <Text size="sm">{`- Type de pilier: ${getItemAbutmentTypeLabel(item)}`}</Text>
      )}
      {item?.abutmentType &&
        shouldTranslate &&
        item?.abutmentType === AbutmentType.STANDARD && (
          <Text size="sm">
            - Standard abutment, we will ship you the parts, please confirm
            abutment height and diameter
          </Text>
        )}
      {item?.abutmentType &&
        shouldTranslate &&
        item?.abutmentType === AbutmentType.STANDARD_GENERIC && (
          <Text size="sm">- Standard 3rd party abutment</Text>
        )}
      {item?.abutmentType &&
        shouldTranslate &&
        item?.abutmentType === AbutmentType.CUSTOM && (
          <Text size="sm">- Abutment type: {item?.abutmentType}</Text>
        )}

      {getImplantRetentionTypeLabel(item) && (
        <Text size="sm">{`- ${getImplantRetentionTypeLabel(item, shouldTranslate)}`}</Text>
      )}
      {getItemAbutmentMaterialLabel(item) && (
        <Text size="sm">{`- ${getItemAbutmentMaterialLabel(item, shouldTranslate)}`}</Text>
      )}
    </>
  );
};
